import { ThreeEvent } from '@react-three/fiber'

const TAP_THRESHOLD = 3

export const handleClick = (callback: (e: ThreeEvent<MouseEvent>) => void) => (e: ThreeEvent<MouseEvent>) => {
  if (e.delta > TAP_THRESHOLD) return
  e.stopPropagation()
  callback(e)
}

export const isLeftMouseButton = (button: number) => button === 0
